import { Controller } from "@hotwired/stimulus";

// Reloads the current page via Turbo. Used by post-add-to-cart modal so the
// "Pokračovať v nákupe" action revisits the page the user was on, refreshing
// stock counts and any other server-rendered state.
export default class extends Controller {
  now(event) {
    event.preventDefault();
    Turbo.visit(window.location.href, { action: "replace" });
  }
}
